import sanityClient from "@sanity/client";

export default sanityClient({
  projectId: "zr6oga9m", 
  dataset: "production", 
  useCdn: true,
  apiVersion: '2021-08-31', // use a UTC date string

});